import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { DatePicker } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
export const dateRangePickerTextsPath = 'common.dateRangePicker';
export const GetDateRangePickerTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            /** @deprecated - don't add new key here!!!! */ DateRangePickerTestIds: {
                From: (testId)=>testId ? "".concat(testId, "-from") : '',
                To: (testId)=>testId ? "".concat(testId, "-to") : ''
            }
        }
    });
export const DateRangePicker = (param)=>{
    let { fromDate, toDate, testId, dateLimits = {}, onChange, onInputBlur, onInputFocus } = param;
    const { t: dateRangePickerTexts } = useLocaleKeys(dateRangePickerTextsPath);
    const { DateRangePickerTestIds } = useMemo(()=>GetDateRangePickerTID(), []);
    const toFromErrorMessage = dateRangePickerTexts.toFromErrorMessage();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(DatePicker, {
                bi: {
                    name: 'date_range_from'
                },
                label: dateRangePickerTexts.fromLabel(),
                testId: DateRangePickerTestIds.From(testId),
                value: fromDate,
                minDate: dateLimits.min,
                maxDate: toDate,
                minDateMessage: dateLimits.minDateMessage,
                maxDateMessage: toFromErrorMessage,
                onChange: (date)=>date && onChange({
                        fromDate: date,
                        toDate
                    }),
                onFocus: onInputFocus,
                onBlur: onInputBlur,
                mobileVariant: "input"
            }),
            /*#__PURE__*/ _jsx(DatePicker, {
                bi: {
                    name: 'date_range_to'
                },
                label: dateRangePickerTexts.toLabel(),
                testId: DateRangePickerTestIds.To(testId),
                value: toDate,
                minDate: fromDate,
                maxDate: dateLimits.max,
                minDateMessage: toFromErrorMessage,
                maxDateMessage: dateLimits.maxDateMessage,
                onChange: (date)=>date && onChange({
                        fromDate,
                        toDate: date
                    }),
                onFocus: onInputFocus,
                onBlur: onInputBlur,
                mobileVariant: "input"
            })
        ]
    });
};
